// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wt-0";
export var confirmationIcon = "_wt-1";